import { Button, IconButton, type UseDisclosureReturn } from '@chakra-ui/react'
import { faHandSparkles } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import chakraTokenToVar from '@/utils/chakraTokenToVar'

import { AI_GUIDE_NAME } from '@/client/services/ai/constants'

export default function AIGuideButton({ onToggle }: Pick<UseDisclosureReturn, 'onToggle'>) {
  return (
    <>
      <Button
        variant="outline"
        bgColor="bg"
        color="fg"
        borderRadius="24px"
        border="2px solid"
        borderColor="primary.border"
        leftIcon={<FontAwesomeIcon icon={faHandSparkles} color={chakraTokenToVar('purple.fg')} />}
        onClick={onToggle}
        mr="16px"
        display={{ base: 'none', sm: 'block' }}
      >
        {AI_GUIDE_NAME}
      </Button>
      <IconButton
        variant="icon"
        icon={<FontAwesomeIcon icon={faHandSparkles} color={chakraTokenToVar('purple.fg')} />}
        onClick={onToggle}
        mr={{ base: '8px', sm: '16px' }}
        display={{ base: 'block', sm: 'none' }}
        aria-label={AI_GUIDE_NAME}
      />
    </>
  )
}
